import { Anchor } from "@svea/design-system-components-react";
import { useText } from "@sveabank/cc-common";
import { useEffect } from "react";
import { Outlet } from "react-router";
import Header from "../components/header";
import PageContainer from "../components/page-container";
import PageFooter from "../features/page-footer";
import { useApplicationId } from "../hooks/useApplicationId";
import { clcApplicationsApiSlice } from "../services/clc-application";
import { useAppDispatch } from "../store";
import { getRevision } from "../utils/storage";
import HeadingLayout from "./heading-layout";

const ClcApplicationLayout = () => {
	const [t, texts] = useText();
	const dispatch = useAppDispatch();
	const applicationId = useApplicationId();

	useEffect(() => {
		const revision = getRevision();

		if (!revision)
			dispatch(
				clcApplicationsApiSlice.endpoints.fetchClcApplicationRevision.initiate(applicationId),
			);
	}, []);

	return (
		<>
			<Header>
				<Anchor
					href={t(texts.newCompany.headerLink)}
					target="_blank"
					iconEnd="externalLink"
					hasUnderline
				>
					{t(texts.newCompany.headerLinkText)}
				</Anchor>
			</Header>

			<HeadingLayout />
			<PageContainer>
				<Outlet />
			</PageContainer>
			<PageFooter />
		</>
	);
};

export default ClcApplicationLayout;
